define.alias("shared/components/shared/asset-upload", "calendar/components/shared/asset-upload");